import React from "react";
import NavBar from "../shared/components/Navbar";
import Footer from "../shared/components/Footer";
import PrivacyPolicy from "../dashboard/components/settings/PrivacyPolicy";

const PrivacyPolicyPage = () => (
  <div className="min-h-screen flex flex-col bg-gray-50">
    <NavBar />
    <main className="flex-1 pt-20">
      <PrivacyPolicy />
    </main>
    <Footer />
  </div>
);

export default PrivacyPolicyPage;